export default __webpack_public_path__ + "9e491301bd039b38a98c51adc5b455b8.png";